import React, { memo } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import UploadPage from './pages/UploadPage';
import DownloadPage from './pages/DownloadPage';
import AccessPage from './pages/AccessPage';
import AccessExpiredPage from './pages/AccessExpiredPage';
import SecureAdminRoute from './pages/SecureAdminRoute';
import StorageStatus from './components/StorageStatus';
import ProtectedRoute from './components/ProtectedRoute';
import { AccessControlProvider } from './contexts/AccessControlContext';

// Memoize the page content to prevent re-renders when StorageStatus updates
const PageContent = memo(() => (
  <Routes>
    {/* Public routes */}
    <Route path="/access" element={<AccessPage />} />
    <Route path="/access-expired" element={<AccessExpiredPage />} />
    <Route path="/demo" element={<UploadPage />} />
    <Route path="/demo/upload" element={<UploadPage />} />
    <Route path="/demo/download" element={<DownloadPage />} />
    <Route path="/7549516669/211fa01046/ID2025009/admin" element={<SecureAdminRoute />} />
    
    {/* Client routes - Simple paths with token validation */}
    <Route path="/" element={
      <ProtectedRoute>
        <UploadPage />
      </ProtectedRoute>
    } />
    <Route path="/upload" element={
      <ProtectedRoute>
        <UploadPage />
      </ProtectedRoute>
    } />
    <Route path="/download" element={
      <ProtectedRoute>
        <DownloadPage />
      </ProtectedRoute>
    } />
    
    {/* Admin routes - Secure paths (for admin access only, NO token validation) */}
    <Route path="/7549516669/211fa01046/ID2025009" element={<UploadPage />} />
    <Route path="/7549516669/211fa01046/ID2025009/upload" element={<UploadPage />} />
    <Route path="/7549516669/211fa01046/ID2025009/download" element={<DownloadPage />} />
  </Routes>
));

PageContent.displayName = 'PageContent';

function AppContent() {
  const location = useLocation();
  // Check if current route is /access or /access-expired - if so, don't show header
  const isMinimalPage = location.pathname === '/access' || location.pathname === '/access-expired';

  return (
    <div className="App">
      {!isMinimalPage && <Header />}
      <main className="container">
        {/* COMMENTED OUT: Storage Status component disabled - no database used in this system */}
        {/* <StorageStatus /> */}
        {!isMinimalPage && <StorageStatus />}
        <PageContent />
      </main>
    </div>
  );
}

function App() {
  return (
    <AccessControlProvider>
      <AppContent />
    </AccessControlProvider>
  );
}

export default App;